import { jsx as _jsx } from "react/jsx-runtime";
import { Scrollbars } from "react-custom-scrollbars";
const CustomScrollbars = (props) => _jsx(Scrollbars, Object.assign({}, props, { autoHide: true, renderTrackHorizontal: props => _jsx("div", Object.assign({}, props, { style: { display: 'none' }, className: "track-horizontal" })) }));
export default CustomScrollbars;
